/**
 * Onboarding API module
 */
import type { OnboardingCompleteRequest, OnboardingCompleteResponse } from '@overlayqa/shared';
import { fetchApi } from './client';
import { log } from '@/lib/logger';
import { MUTATION_TIMEOUT_MS } from './requestTimeout';

log.info('[api/onboarding] Module loaded');

export const onboardingApi = {
  /** Can the weekly scan reach this URL? Asked by the wizard once the URL field settles. */
  scanPreflight: (token: string | undefined, url: string) =>
    fetchApi<{ scannable: boolean; reason: string }>('/onboarding/scan-preflight', {
      token,
      method: 'POST',
      timeoutMs: MUTATION_TIMEOUT_MS,
      body: JSON.stringify({ url }),
    }),
  complete: (token: string | undefined, data: OnboardingCompleteRequest) =>
    fetchApi<OnboardingCompleteResponse>('/onboarding/complete', {
      token,
      method: 'POST',
      timeoutMs: MUTATION_TIMEOUT_MS,
      body: JSON.stringify(data),
    }),
};
